<div class="error_page">
  <div class="error_page_name">500</div>
  <img src="/assets/img/404-error.png" alt="" class="error_page_img">
  <div class="error_page_title">Sorry!</div>
  <div class="error_page_text">Sorry, we have encountered some issues on our server and are already working on fixing it.  Please, refresh the webpage in a few minutes.</div>
  <a class="error_page_btn" *ngIf="overViewAvailable$ | async" [routerLink]="toOverview">Go to Overview Page</a>
</div>
<div id="roadmap-paint-finished"></div>
